// =============================================================================
// AGC: DROID FARM - AI Sparkles Icon
// AGC: Animated sparkles icon for AI One-Click Measuring feature
// =============================================================================

import React from 'react';

interface SparklesIconProps {
  className?: string;
  animated?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * AGC: Sparkles icon component for AI features
 * AGC: Supports animation and multiple sizes
 */
export const SparklesIcon: React.FC<SparklesIconProps> = ({ 
  className = '', 
  animated = false,
  size = 'md' 
}) => {
  // AGC: Size mapping
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
  };

  return (
    <svg 
      className={`${sizes[size]} ${className} ${animated ? 'animate-sparkle' : ''}`}
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* AGC: Main sparkle shape */}
      <path 
        d="M12 2L13.09 8.26L19 6L14.74 10.91L21 12L14.74 13.09L19 18L13.09 15.74L12 22L10.91 15.74L5 18L9.26 13.09L3 12L9.26 10.91L5 6L10.91 8.26L12 2Z" 
        fill="currentColor"
        className={animated ? 'animate-pulse' : ''}
      />
      {/* AGC: Top-right small sparkle */}
      <circle 
        cx="19" cy="5" r="1.5" 
        fill="currentColor"
        className={animated ? 'animate-ping' : ''}
        style={{ animationDuration: '2s' }}
      />
      {/* AGC: Bottom-left small sparkle */}
      <circle 
        cx="5" cy="19" r="1" 
        fill="currentColor"
        className={animated ? 'animate-ping' : ''}
        style={{ animationDuration: '2.5s', animationDelay: '0.5s' }}
      />
    </svg>
  );
};

export default SparklesIcon;

